export const AUDIENCE_VOTE_CONTESTANT_PHOTO_ROOT =
  "uploads/audience-vote" as const;

export function audienceVoteContestantPhotoKeyPrefix(eventId: string) {
  return `${AUDIENCE_VOTE_CONTESTANT_PHOTO_ROOT}/${eventId}`;
}

export function isHttpUrl(value: string): boolean {
  try {
    const u = new URL(value);
    return u.protocol === "http:" || u.protocol === "https:";
  } catch {
    return false;
  }
}

/** Storage key under this event's contestant artwork folder */
export function isAudienceVoteContestantPhotoStorageKey(
  key: string,
  eventId: string,
): boolean {
  const prefix = `${audienceVoteContestantPhotoKeyPrefix(eventId)}/`;
  return key.startsWith(prefix) && key.length > prefix.length;
}

export function isValidContestantPhotoRef(
  value: string,
  eventId: string,
): boolean {
  if (isHttpUrl(value)) return true;
  return isAudienceVoteContestantPhotoStorageKey(value, eventId);
}
